
import React, { useState, useEffect, useRef } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import { Tooltip, useMediaQuery } from "@mui/material";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { MdDashboard } from "react-icons/md";
import MailIcon from "@mui/icons-material/Mail";
import logo from "../assets/Images/Clanbridge-logo-White.png";
import { VscThreeBars } from "react-icons/vsc";
import { MdOutlineReport } from "react-icons/md";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import PeopleIcon from "@mui/icons-material/People";
import AccessibilityIcon from "@mui/icons-material/Accessibility";
import ApartmentIcon from "@mui/icons-material/Apartment";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import BuildIcon from "@mui/icons-material/Build";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PaymentsIcon from "@mui/icons-material/Payments";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import ChecklistRtlIcon from "@mui/icons-material/ChecklistRtl";
import InventoryIcon from "@mui/icons-material/Inventory";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import OtherHousesIcon from "@mui/icons-material/OtherHouses";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import EventSeatIcon from "@mui/icons-material/EventSeat";
import TaskIcon from "@mui/icons-material/Task";
import InventoryRoundedIcon from "@mui/icons-material/InventoryRounded";
import SecurityRoundedIcon from "@mui/icons-material/SecurityRounded";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import ErrorOutlineSharpIcon from "@mui/icons-material/ErrorOutlineSharp";
import ManSharpIcon from "@mui/icons-material/ManSharp";
import InventoryTwoToneIcon from "@mui/icons-material/InventoryTwoTone";
import ChatTwoToneIcon from "@mui/icons-material/ChatTwoTone";
import HowToRegTwoToneIcon from "@mui/icons-material/HowToRegTwoTone";
import LocalActivityTwoToneIcon from "@mui/icons-material/LocalActivityTwoTone";
import AccountBalanceTwoToneIcon from "@mui/icons-material/AccountBalanceTwoTone";
import ReceiptTwoToneIcon from "@mui/icons-material/ReceiptTwoTone";
import StorefrontTwoToneIcon from "@mui/icons-material/StorefrontTwoTone";
import GroupsIcon from "@mui/icons-material/Groups";
import Entity from "../Components/Entity";
import { dataRetrivewApi } from "../../src/Api/Userpermission/Api";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserPermissions, selectPermissions, } from "../redux/permissionsSlice";
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import SearchModule from '../../src/atoms/Searchbox/Searchbox';
import SearchBoxWithVoice from '../../src/atoms/Searchbox/SearchBoxWithVoice';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PushPinIcon from '@mui/icons-material/PushPin';
import PropertyDropdown from '../redux/PropertyDropdown';
import SearchIcon from '@mui/icons-material/Search';
import ApartmentTwoToneIcon from '@mui/icons-material/ApartmentTwoTone';
import AllInboxIcon from '@mui/icons-material/AllInbox';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RecentlyVisitedIcon from '../Components/RecentlyVisitedIcon';
import { addVisitedItem } from '../redux/recentlyVisitedSlice';
import FolderIcon from '@mui/icons-material/Folder';

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

function SidebarDrawar({ children }) {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [userName, setUserName] = useState("");
  const [mastersOpen, setMastersOpen] = useState(false);
  const [operationsOpen, setOperationsOpen] = useState(false);
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const [billingsOpen, setBillingsOpen] = useState(false);
  const [inventoryOpen, setInventoryOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false);
  const [utilitiesOpen, setUtilitiesOpen] = useState(false);
  const [UserPermission, setUserPermissionOpen] = useState(false);
  const dispatch = useDispatch();
  const userPermissions = useSelector(selectPermissions);
  const userId = sessionStorage.getItem("UserId");
  const [anchorElFav, setAnchorElFav] = useState(null);
  const [propertyMenuOpen, setPropertyMenuOpen] = useState(false);
  const [searchMenuOpen, setSearchMenuOpen] = useState(false);
  const iconButtonRef = useRef(null);
  const iconContainerRef = useRef(null);
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [foodTransportOpen, setFoodTransportOpen] = useState(false);

  useEffect(() => {
    if (userId) {
      dispatch(fetchUserPermissions(userId));
    }
  }, [dispatch, userId]);

  const hasModulePermission = (moduleName) => {
    const modulePermission = userPermissions.find(
      (permission) => permission.ModuleName === moduleName
    );
    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };

  const handleFavoritesClick = () => {
    navigate('/favoritelistcomponnet');
  };

  const trackSidebarNavigation = (title, path) => {
    dispatch(addVisitedItem({
      title,
      path
    }));
  };

  const handleFavoritesClose = () => {
    setAnchorElFav(null);
  };

  const openFavorites = Boolean(anchorElFav);
  const favoritesId = openFavorites ? 'favorites-popover' : undefined;

  const handlePropertyMenuClick = () => {
    setPropertyMenuOpen(!propertyMenuOpen);
    setSearchMenuOpen(false); // Close search menu if open
  };

  const handleSearchMenuClick = () => {
    setSearchMenuOpen(!searchMenuOpen);
    setPropertyMenuOpen(false); // Close property menu if open
  };

  const handlePropertyMenuClose = () => {
    setPropertyMenuOpen(false);
  };

  const handleSearchMenuClose = () => {
    setSearchMenuOpen(false);
  };
  const renderMenuItem = (moduleName, icon, path, subItems = null) => {
    if (!hasModulePermission(moduleName)) return null;

    return (
      <ListItem disablePadding sx={{ display: "block" }}>
        <ListItemButton
          onClick={() => handleNavigation(path)}
          sx={{
            minHeight: 48,
            justifyContent: open ? "initial" : "center",
            px: 2.5,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: open ? 3 : "auto",
              justifyContent: "center",
            }}
          >
            {icon}
          </ListItemIcon>
          <ListItemText primary={moduleName} sx={{ opacity: open ? 1 : 0 }} />
          {subItems &&
            open &&
            (subItems.isOpen ? (
              <ExpandLess sx={{ mr: "-10px" }} />
            ) : (
              <ExpandMore sx={{ mr: "-10px" }} />
            ))}
        </ListItemButton>
        {subItems && (
          <Collapse in={subItems.isOpen && open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {subItems.items.map(
                (item, index) =>
                  hasModulePermission(item.name) && (
                    <ListItemButton
                      key={index}
                      sx={{ pl: 4 }}
                      onClick={() =>
                        handleSubMenuNavigation(item.path, userPermissions)
                      }
                      selected={location.pathname === item.path}
                    >
                      <ListItemIcon sx={{ minWidth: 40 }}>
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText primary={item.name} />
                    </ListItemButton>
                  )
              )}
            </List>
          </Collapse>
        )}
      </ListItem>
    );
  };

  const handleSubMenuNavigation = (path, permissions, title) => {
    // Track the navigation
    if (title) {
      trackSidebarNavigation(title, path);
    }
    navigate(path, { state: { permissions: userPermissions } });
    setOpen(true);
  };

  const mastersSubItems = [
    {
      name: "Company",
      path: "/masters/company",
      icon: <CorporateFareIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Property",
      path: "/masters/property",
      icon: <ApartmentIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Ar/Ap",
      path: "/masters/arap",
      icon: <PeopleIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Location",
      path: "/masters/location",
      icon: <LocationOnIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Accounts",
      path: "/masters/accounts",
      icon: <AccountBoxIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Ticketing",
      path: "/masters/ticketing",
      icon: <EventSeatIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Assets/Store",
      path: "/masters/AssetStore",
      icon: <CloudDoneIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Operations",
      path: "/masters/operations",
      icon: <TaskIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Inventory",
      path: "/masters/inventory",
      icon: <InventoryRoundedIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Other Master",
      path: "/masters/other-master",
      icon: <MoreHorizIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Control & Security",
      path: "/masters/control-security",
      icon: <SecurityRoundedIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "GST/SAC Code",
      path: "/masters/gst-code",
      icon: <RequestQuoteOutlinedIcon sx={{ color: "#dddbff" }} />,
    },
  ];
  const operationsSubItems = [
    {
      name: "House Keeping",
      path: "/operations/housekeepin",
      icon: <HomeRepairServiceIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Maintenance & PPM",
      path: "/operations/maintenance",
      icon: <BuildIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Transport & Tiffin",
      path: "/operations/transport",
      icon: <EmojiTransportationIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "H.R",
      path: "/operations/hr",
      icon: <ManSharpIcon sx={{ color: "#dddbff" }} />,
    },
  ];
  const bookingpaymentItem = [
    {
      name: "Booking(Pre-Registration)",
      path: "/enquiry/pre-registration",
      icon: <AssignmentIcon sx={{ color: "#dddbff" }} />,
    },
    // {
    //   name: "Checkout & handover",
    //   path: "/enquiry/checkout-handove",
    //   icon: <AllInboxIcon sx={{ color: "#dddbff" }} />,
    // },
    {

      name: "Registration",
      path: "/enquiry/registration",
      icon: <AccountCircleIcon sx={{ color: "#dddbff" }} />,
    },
  ];
   const foodTransportItems = [
  {
    name: "Food & Tiffin Services",
    path: "/food-transport",
    icon: <FastfoodIcon sx={{ color: "#dddbff" }} />,
  },
 
];
  const checkouttItem = [

    {
      name: "Checkout & Handover",
      path: "/checkouttab",
      icon: <AllInboxIcon sx={{ color: "#dddbff" }} />,
    },

  ];
  const billings = [
    {
      name: "Billing",
      path: "/billings/billing",
      icon: <PaymentsIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Complaint",
      path: "/billings/complaint",
      icon: <ErrorOutlineSharpIcon sx={{ color: "#dddbff" }} />,
    },
  ];

  const storesInventory = [
    {
      name: "Inward-Outward",
      path: "/inventory/inward-outward",
      icon: <StorefrontTwoToneIcon sx={{ color: "#dddbff" }} />,
    },
  ];

  const financeAccounts = [
    {
      name: "Vouchers",
      path: "/accounts/vouchers",
      icon: <ReceiptTwoToneIcon sx={{ color: "#dddbff" }} />,
    },
  ];

  const reports = [
    {
      name: "Enq & Registration",
      path: "/reports/enq-registration",
      icon: <HowToRegTwoToneIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Operations",
      path: "/reports/operations",
      icon: <LocalActivityTwoToneIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Accounts & Finance",
      path: "/reports/accountsFinance",
      icon: <AccountBalanceTwoToneIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Bed Calender",
      path: "/reports/calender",
      icon: <AccountBalanceTwoToneIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Booking Report",
      path: "/reports/bookdetails",
      icon: <AccountBalanceTwoToneIcon sx={{ color: "#dddbff" }} />,
    },
  ];

  const utilities = [
    {
      name: "Directory",
      path: "/utilities",
      icon: <FolderIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "Notice Board",
      path: "/info-board-table",
      icon: <ChatTwoToneIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "BroadCast Master",
      path: "/broadcasttable",
      icon: <ChatTwoToneIcon sx={{ color: "#dddbff" }} />,
    },
    {
      name: "BroadCasting",
      path: "/broadcastingtable",
      icon: <ChatTwoToneIcon sx={{ color: "#dddbff" }} />,
    },
  ];

  const userpermission = [
    {
      name: "User & Permission",
      path: "/userpermission",
      icon: <GroupsIcon sx={{ color: "#dddbff" }} />,
    },
  ];

  const toggleDrawer = () => {
    navigate('/masters/company')
    setOpen(!open);
  };

  const handleOutsideClick = (event) => {
    if (
      open &&
      !event.target.closest(".MuiDrawer-paper") &&
      !event.target.closest(".MuiIconButton-edgeStart")
    ) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [open]);
  const handleMastersClick = () => {
    setMastersOpen(!mastersOpen);
  };

  useEffect(() => {
    const storedUserName = localStorage.getItem("userName");
    if (storedUserName) {
      setUserName(storedUserName);
    }
  }, []);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleNavigation = (path) => {
    navigate(path);
    console.log("Navigating to:", path);
    if (path === "/masters") {
      const firstPermittedPath = mastersSubItems.find((item) =>
        hasModulePermission(item.name)
      )?.path;

      if (firstPermittedPath) {
        navigate(firstPermittedPath, {
          state: { permissions: userPermissions },
        });
      } else {
        navigate(path, { state: { permissions: userPermissions } });
      }

      setMastersOpen(!mastersOpen);
      setOperationsOpen(false);
      setEnquiryOpen(false);
    } else if (path === "/operations/housekeepin") {
      const firstPermittedPath = operationsSubItems.find((item) =>
        hasModulePermission(item.name)
      )?.path;

      if (firstPermittedPath) {
        navigate(firstPermittedPath, {
          state: { permissions: userPermissions },
        });
      } else {
        navigate(path, { state: { permissions: userPermissions } });
      }
      setOperationsOpen(!operationsOpen);
    } else if (path === "/enquiry") {
      const firstPermittedPath = bookingpaymentItem.find((item) =>
        hasModulePermission(item.name)
      )?.path;

      if (firstPermittedPath) {
        navigate(firstPermittedPath, {
          state: { permissions: userPermissions },
        });
      } else {
        navigate(path, { state: { permissions: userPermissions } });
      }

      setEnquiryOpen(!enquiryOpen);

    }
    // Add this condition in the handleNavigation function
    else if (path === "/checkout") {
      const firstPermittedPath = checkouttItem.find((item) =>
        hasModulePermission(item.name)
      )?.path;

      if (firstPermittedPath) {
        navigate(firstPermittedPath, {
          state: { permissions: userPermissions },
        });
      } else {
        navigate(path, { state: { permissions: userPermissions } });
      }

      setCheckoutOpen(!checkoutOpen);
    }
    else if (path === "/food-transport") {
  const firstPermittedPath = foodTransportItems.find((item) =>
    hasModulePermission(item.name)
  )?.path;

  if (firstPermittedPath) {
    navigate(firstPermittedPath, {
      state: { permissions: userPermissions },
    });
  } else {
    navigate(path, { state: { permissions: userPermissions } });
  }
  setFoodTransportOpen(!foodTransportOpen);
}

    else if (path === "/billings") {
      const firstPermittedPath = billings.find((item) =>
        hasModulePermission(item.name)
      )?.path;

      if (firstPermittedPath) {
        navigate(firstPermittedPath, {
          state: { permissions: userPermissions },
        });
      } else {
        navigate(path, { state: { permissions: userPermissions } });
      }
      setBillingsOpen(!billingsOpen);
    } else if (path === "/inventory") {
      const firstPermittedPath = storesInventory.find((item) =>
        hasModulePermission(item.name)
      )?.path;

      if (firstPermittedPath) {
        navigate(firstPermittedPath, {
          state: { permissions: userPermissions },
        });
      } else {
        navigate(path, { state: { permissions: userPermissions } });
      }
      setInventoryOpen(!inventoryOpen);
    } else if (path === "/accounts") {
      const firstPermittedPath = financeAccounts.find((item) =>
        hasModulePermission(item.name)
      )?.path;

      if (firstPermittedPath) {
        navigate(firstPermittedPath, {
          state: { permissions: userPermissions },
        });
      } else {
        navigate(path, { state: { permissions: userPermissions } });
      }
      setAccountOpen(!accountOpen);
    } else if (path === "/reports") {
      setReportsOpen(!reportsOpen);
    } else if (path === "/utilities") {
      const firstPermittedPath = utilities.find((item) =>
        hasModulePermission(item.name)
      )?.path;

      if (firstPermittedPath) {
        navigate(firstPermittedPath, {
          state: { permissions: userPermissions },
        });
      } else {
        navigate(path, { state: { permissions: userPermissions } });
      }
      setUtilitiesOpen(!utilitiesOpen);
    } else if (path === "/userpermission") {
      setUserPermissionOpen(!UserPermission);
    } else {
      setMastersOpen(false);
      setOperationsOpen(false);
    }
  };
  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileClose = () => {
    setAnchorEl(null);
  };

  const handleMyAccountClick = () => {
    handleProfileClose();
    navigate("/changepassword");
  };

  const handleBackupClick = () => {
    navigate("/backup");
  };

  const handleLogout = () => {
    localStorage.removeItem("userName");
    localStorage.removeItem("isLoggedIn");
    sessionStorage.clear();
    navigate("/");
    handleProfileClose();
  };

  const handleDrawerEnter = () => {
    if (window.innerWidth > 600) {
      setOpen(true);
    }
  };

  const handleDrawerLeave = () => {
    if (window.innerWidth > 600) {
      setOpen(false);
    }
  };

  const handleDrawerToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (!open) {
      setMastersOpen(false);
      setOperationsOpen(false);
      setEnquiryOpen(false);
      setBillingsOpen(false);
      setInventoryOpen(false);
      setAccountOpen(false);
      setCheckoutOpen(false);
      setReportsOpen(false);
      setUtilitiesOpen(false);
      setUserPermissionOpen(false);
        setFoodTransportOpen(false)
    }
  }, [open]);

  // Check if the current path is "/raise-service-tkt"  raise-tkt-dashboard
  const isServiceTicketRoute = location.pathname === "/raise-service-tkt"
    || location.pathname === "/task-assignment"
    || location.pathname === "/task-acceptance"
    || location.pathname === "/raise-tkt-dashboard"
    || location.pathname === "/task-status"
    || location.pathname === "/dashboard";

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed">
        <Toolbar sx={{ backgroundColor: "#635bff" }}>
          <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={toggleDrawer}>
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            {isMobile ? (
              <Box ref={iconContainerRef} sx={{ display: 'flex', alignItems: 'center', gap: 0, ml: '0.5px', mt: '4px' }}>
                <PropertyDropdown />
                <IconButton
                  aria-controls={searchMenuOpen ? "search-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={searchMenuOpen ? "true" : undefined}
                  color="inherit"
                  onClick={handleSearchMenuClick}
                  sx={{ pr: 1 }}
                >
                  <SearchIcon />
                </IconButton>
                <Menu
                  id="search-menu"
                  anchorEl={iconContainerRef.current}
                  open={searchMenuOpen}
                  onClose={handleSearchMenuClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  slotProps={{
                    paper: {
                      sx: {
                        minWidth: 300, // Increased width for voice search
                        p: 1,
                      },
                    },
                  }}
                >
                  {/* <SearchModule /> */}
                  <SearchBoxWithVoice />
                </Menu>
              </Box>
            ) : (
              <Box
                component="img"
                src={logo}
                alt="logo"
                sx={{ height: { xs: 25, sm: 45, md: 45 }, mt: '8px', ml: '20px' }}
              />
            )}
          </Typography>
          {!isMobile && (
            <>
              <PropertyDropdown />
              {/* <SearchModule /> */}
              <SearchBoxWithVoice />
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <RecentlyVisitedIcon />
                <CircleNotificationsIcon />
                <Typography>{userName}</Typography>
              </Box>
            </>
          )}
          <IconButton
            color="inherit"
            onClick={handleFavoritesClick}
            aria-describedby={favoritesId}
            sx={{
              ml: { xs: 0, sm: 1 },
              px: { xs: 0, sm: 1 }
            }} // Reduced on mobile
          >
            <PushPinIcon />
          </IconButton>
          <IconButton
            onClick={handleProfileClick}
            size="small"
            sx={{ ml: { xs: 0, sm: 1 } }}
            aria-controls={Boolean(anchorEl) ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={Boolean(anchorEl) ? "true" : undefined}
          >
            <Avatar sx={{ width: 32, height: 32 }}>
              {userName[0]?.toUpperCase()}
            </Avatar>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={Boolean(anchorEl)}
            onClose={handleProfileClose}
            onClick={handleProfileClose}
          >
            <MenuItem style={{ color: "#635bff" }}>
              {" "}
              Hello!{" "}
              {userName &&
                userName.charAt(0).toUpperCase() +
                userName.split(" ")[0].slice(1)}
            </MenuItem>
            <MenuItem onClick={handleMyAccountClick}>Change Password</MenuItem>
            <MenuItem onClick={handleBackupClick}>BackUp</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {!isServiceTicketRoute && (
        <Drawer
          variant="permanent"
          open={open}
          onMouseEnter={handleDrawerEnter}
          onMouseLeave={handleDrawerLeave}
          sx={{
            '& .MuiDrawer-paper': {
              display: 'flex',
              flexDirection: 'column',
              overflowY: 'auto',
              scrollbarWidth: 'none', // For firefox
              msOverflowStyle: 'none', // For internet explorer
            },
          }}
        >
          <DrawerHeader>
            <IconButton onClick={toggleDrawer}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </DrawerHeader>
          <Divider />
          <List>
            {renderMenuItem(
              "Dashboard",
              <MdDashboard style={{ fontSize: "25px", color: "#635bff" }} />,
              "/dashboard"
            )}

            {renderMenuItem(
              "Masters",
              <VscThreeBars style={{ fontSize: "25px", color: "#635bff" }} />,
              "/masters",
              { isOpen: mastersOpen, items: mastersSubItems }
            )}

            {renderMenuItem(
              "Booking & Payment",
              <HowToRegIcon sx={{ color: "#635bff" }} />,
              "/enquiry",
              { isOpen: enquiryOpen, items: bookingpaymentItem }
            )}
           
            {renderMenuItem(
              "Checkout & Handover",
              <CheckCircleOutlineIcon sx={{ color: "#635bff" }} />,
              "/checkouttab",
              { isOpen: checkoutOpen, items: checkouttItem }
            )}


            {renderMenuItem(
              "Service & Ticket",
              <AccountBalanceWalletIcon sx={{ color: "#635bff" }} />,
              "/billings",
              { isOpen: billingsOpen, items: billings }
            )}

            {renderMenuItem(
              "Operations (HK)",
              <LocalActivityIcon sx={{ color: "#635bff" }} />,
              "/operations/housekeepin",
              { isOpen: operationsOpen, items: operationsSubItems }
            )}
             {renderMenuItem(
              "Food & Tiffin Services",
              <FastfoodIcon sx={{ color: "#635bff" }} />,
              "/food-transport",
              { isOpen: foodTransportOpen, items: foodTransportItems }
            )}

            {renderMenuItem(
              "Stores & Inventory",
              <InventoryIcon style={{ fontSize: "25px", color: "#635bff" }} />,
              "/inventory",
              { isOpen: inventoryOpen, items: storesInventory }
            )}

            {renderMenuItem(
              "Finance & Accounts",
              <AccountBalanceIcon
                style={{ fontSize: "25px", color: "#635bff" }}
              />,
              "/accounts",
              { isOpen: accountOpen, items: financeAccounts }
            )}

            {renderMenuItem(
              "Reports",
              <LeaderboardIcon sx={{ color: "#635bff" }} />,
              "/reports",
              { isOpen: reportsOpen, items: reports }
            )}

            {renderMenuItem(
              "Utilities & Others",
              <OtherHousesIcon sx={{ color: "#635bff" }} />,
              "/utilities",
              { isOpen: utilitiesOpen, items: utilities }
            )}

            {renderMenuItem(
              "User & Permission",
              <GroupsIcon sx={{ color: "#635bff" }} />,
              "/userpermission",
              { isOpen: UserPermission, items: userpermission }
            )}
          </List>
          <Divider />
        </Drawer>
      )}

      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        {children}
      </Box>
    </Box>
  );
}

export default SidebarDrawar;

